class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.loader = this.querySelector('.loader-container');

    this.querySelectorAll('.btn-input-mount').forEach( (numButtons) => 
      numButtons.addEventListener('click', this.numButtonsEvent.bind(this))
    );
  }

  updateShippingBar(){
    let total = document.querySelector('.mount-subtotal');
    let input_ = this.querySelector('.input-freeshiping');
    var annoument_cart = document.querySelector('.container-cart .annoument .text');
    let bar = this.querySelector('.bar');
    let number = total != null ? total.innerText.replace('$', '') : '';
    input_.value = parseFloat(number);
    let price_free_shipping = parseFloat(`${cart_properties.price_free_shipping}`);
    
    if(parseFloat(number) < price_free_shipping ) {
      let porcentaje = parseFloat(number) / price_free_shipping;
      let array_ = porcentaje.toFixed(2).toString()
      let value_ = array_.split('.')
      bar.style.cssText = 'width: '+ parseInt(value_[1]) +'%;';
      annoument_cart.textContent = cart_properties.price_free_below;
    } else if (isNaN(parseFloat(number))) {
      bar.style.cssText = 'width: 0%;';
      annoument_cart.textContent = cart_properties.price_free_below;
    } else {
      bar.style.cssText = 'width: 100%;';
      annoument_cart.textContent = cart_properties.price_free_up;
    }
  }

  bindedAgainButtons(){
    this.querySelectorAll('.btn-input-mount').forEach( (numButtons) => 
      numButtons.addEventListener('click', this.numButtonsEvent.bind(this))
    );
  }

  open() {
      this.querySelector('.hidden-cart').classList.add('active')
      setTimeout(() => {
        this.querySelector('div.cart').classList.add('active')
        this.querySelector('.container-cart').classList.add('active')
        document.body.style.cssText = 'overflow: hidden;';
        document.querySelector("html").style.cssText = 'overflow: hidden;';
      }, 200);
  }

  numButtonsEvent(elm){
    elm.preventDefault();
    var id = elm.target.dataset.id;
    var action = elm.target.dataset.action;
    var qtyInput = this.querySelector('.input-mount-'+id);
    if(action == 'plus'){
      qtyInput.value++;
    }else{
      if(qtyInput.value > 0){
        qtyInput.value--;
      }
    }
    this.changleHandled(id, qtyInput.value);
  }

  changleHandled(id, qty){
    let loader = this.loader;
    loader.style.display = 'flex';

    fetch('/cart/change.js', {
      body:  JSON.stringify({ 'id': id, 'quantity': qty, sections: this.getSectionsToRender().map((section) => section.id) }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    })
    .then((response) => response.json())
    .then((parsedState) => {
      this.renderContents(parsedState);
      loader.style.display = 'none';
    }).catch(function(err) {
      loader.style.display = 'none';
      console.error(err)
    });
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.header?.reveal();
      this.open();
      this.bindedAgainButtons();
      this.updateShippingBar();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

